import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "trigger"]

  connect() {
    this.showTimeout = null
    this.hideTimeout = null
  }

  disconnect() {
    this.clearTimeouts()
  }

  mouseEnter() {
    this.clearTimeouts()
    this.showTimeout = setTimeout(() => {
      this.showCard()
    }, 200)
  }

  mouseLeave() {
    this.clearTimeouts()
    this.hideTimeout = setTimeout(() => {
      this.hideCard()
    }, 200)
  }

  cardMouseEnter() {
    this.clearTimeouts()
  }

  cardMouseLeave() {
    this.hideCard()
  }

  showCard() {
    this.cardTarget.classList.remove("hidden")
    this.positionCard()
  }

  hideCard() {
    this.cardTarget.classList.add("hidden")
  }

  clearTimeouts() {
    if (this.showTimeout) {
      clearTimeout(this.showTimeout)
      this.showTimeout = null
    }
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
    }
  }

  positionCard() {
    const triggerRect = this.triggerTarget.getBoundingClientRect()
    const card = this.cardTarget
    const cardHeight = card.offsetHeight
    const cardWidth = card.offsetWidth

    const spaceAbove = triggerRect.top
    const spaceBelow = window.innerHeight - triggerRect.bottom

    let top
    if (spaceAbove >= cardHeight + 10 || spaceAbove > spaceBelow) {
      top = triggerRect.top - cardHeight - 10
    } else {
      top = triggerRect.bottom + 10
    }

    let left = triggerRect.left
    if (window.innerWidth - left < cardWidth) {
      left = window.innerWidth - cardWidth - 20
    }

    card.style.top = `${Math.max(10, top)}px`
    card.style.left = `${Math.max(10, left)}px`
  }
}
